import { api } from "../client";
import {
  TaskExtraFields,
  TaskFields,
  PartialTaskExtraFields,
  PartialTaskFields,
} from "../schema/Task";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<TaskFields, TaskExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialTaskFields,
  PartialTaskExtraFields
>;

export const getTasks = async (config?: ApiRequestConfig) => {
  return api.get<TaskFields, TaskExtraFields>("tasks", config);
};
export const getTask = (id: number, config?: ApiRequestConfig) => {
  return api.get<TaskFields, TaskExtraFields>(`tasks/${id}`, config);
};

export const createTask = (config: ApiRequestConfigMutate) => {
  return api.create<PartialTaskFields, PartialTaskExtraFields>("tasks", config);
};
export const updateTask = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<PartialTaskFields, PartialTaskExtraFields>(
    `tasks/${id}`,
    config
  );
};
export const deleteTask = (id: number) => {
  return api.remove<TaskFields, TaskExtraFields>(`tasks/${id}`);
};
